import React from "react";
import 'suneditor/dist/css/suneditor.min.css';
import SunEditor from "suneditor-react";
import "./style.less"
import {TextEditorProps} from "./types";
import {uploadService} from "../../services/uploadService";
import {useUploadController} from "../../controllers/upload-controller";
import * as BUCKETS from "../../enums/buckets"
import {getImageLink} from "../../helpers/mainHelpers";
import {UploadBeforeHandler} from "suneditor-react/dist/types/upload";


const TextEditor: React.FC<TextEditorProps> = (props) => {
  const {value, setValue} = props
  const { uploadSunEditorContentImage} = useUploadController()

const onImageUploadBefore = (files: File[], info: object, uploadHandler: UploadBeforeHandler)  =>{
  const file = files[0];
  if(file){

    uploadSunEditorContentImage({file}).then((response =>{
      if(response){
        const previewUrl = getImageLink({imageId: response.$id, bucketId: BUCKETS.MAIN})

        uploadHandler({
          result: [{ url: previewUrl, name: file.name, size: file.size }],
        });
      }
    })).catch((error)=>{
      console.error(error)
      uploadHandler()
    })
  }
  return undefined;
}


  return (
    <div className="textEditor_wrapper">
      <SunEditor
        lang="ua"
        disable={false}
        key="text_editor"
        onImageUploadBefore={onImageUploadBefore}
        setOptions={{
          buttonList: [
            ["font", "fontSize", "formatBlock"],
            ["paragraphStyle", "blockquote"],
            ["fontColor", "hiliteColor", "textStyle"],
            ["bold", "underline", "italic", "strike", "subscript"],
            ["outdent", "indent"],
            ["align", "horizontalRule", "list", "lineHeight"],
            ["image", "video"],
          ],
          font: [
            "Arial",
            "Comic Sans MS",
            "Courier New",
            "Georgia",
            "Impact",
            "Tahoma",
            "Times New Roman",
            "Verdana",
          ],
        }}
        setContents={value}
        onChange={(content) => {
          setValue(content)
        }}
        width="100%"
        height="100%"
      />

    </div>
  );
};

export default TextEditor;